export default __webpack_public_path__ + "static/media/component.2cb50202.md";